import type { FrameData } from './types';

export function makeDefault(): FrameData {
  return {
    title: '',
    /** Default body fill — opaque hex so --frame-fill-opacity can modulate
     *  the alpha independently. The combined visual is the same as the old
     *  rgba(141,169,196,0.06): blue-gray at ~6% opacity. */
    fill: '#8DA9C4',
    /** Default border color — matches the dashed-border treatment shapes
     *  use as their default. Mirrors Sticky's data.stroke. */
    stroke: 'var(--outline-variant)',
    strokeOpacity: 1,
    /** Default border style — dashed reads as "container, not finalized
     *  shape", matching the frame's pre-strokeStyle visual. */
    strokeStyle: 'dashed',
    titleColor: '#2D3134',
    fillOpacity: 0.06,
    collapsed: false,
    /** Default closed-state icon. The component reads this via withDefaults
     *  so legacy frames missing the field render with the folder icon when
     *  collapsed without requiring a doc migration. */
    icon: 'folder',
    childOrder: [],
  };
}
